// extracted by mini-css-extract-plugin
module.exports = {"comboButtons":"Description_comboButtons__CJQkw","row":"Description_row___MMpa","comboCards":"Description_comboCards__oaSFT","description":"Description_description__M3_aj"};